<template>
  <div class="payment-link-bg">
    <div class="payment-link-container" :style="{ display: display }">
      <div class="prclx-logo" :class="{ loading: isLoading }">
        <asset-v3
          :style="{ marginLeft: isLarge ? marginLeft : '24px', marginTop: '24px' }"
          dir="logos"
          name="logo.svg"
        />
      </div>

      <loading-page v-if="isLoading" ref="loading-page" @finish="finishLoading" />

      <div
        class="payment-link-content"
        :style="{ height: fullHeight ? '100%' : 'auto' }"
        v-if="!isLoading"
      >
        <slot name="content"></slot>
      </div>

      <div class="payment-link-footer" v-if="hasFooterSlot && !isLoading">
        <slot name="footer"></slot>
      </div>

      <security-warning
        v-if="!hideSecurityWarning && !isLoading && !hideSecurityWarningOnMobile"
        class="hide-on-large pb-12"
      />
    </div>

    <security-warning v-if="!hideSecurityWarning" class="only-on-large pb-32" />
  </div>
</template>

<script>
import AssetV3 from '@/components/common/AssetV3.vue';
import SecurityWarning from '../components/SecurityWarning.vue';
import LoadingPage from '../components/LoadingPage.vue';

export default {
  name: 'PaymentLinkLayout',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    marginLeft: {
      type: String,
      default: 'auto',
    },
    display: {
      type: String,
      default: 'grid',
    },
    fullHeight: {
      type: Boolean,
      default: false,
    },
    hideSecurityWarning: {
      type: Boolean,
      default: false,
    },
    hideSecurityWarningOnMobile: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SecurityWarning,
    AssetV3,
    LoadingPage,
  },
  computed: {
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
    isLarge() {
      return window.innerWidth > 768;
    },
  },
  methods: {
    finishLoading({ success = true } = {}) {
      this.$refs['loading-page'].finishLoading({ success });
      setTimeout(
        () => {
          this.$emit('finishLoading');
        },
        success ? 2000 : 0,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/__new-styles.scss";

.payment-link-bg {
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);

  @media (min-width: $breakpoint-large) {
    background-color: $gray-50;
    padding-top: 22px;
    padding-bottom: 1px;
    height: 100%;
    min-height: 100vh;
  }
}

.payment-link-container {
  background-color: $white;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: auto 3fr 80px 20px;
  grid-template-columns: 1fr;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);

  @media (min-width: $breakpoint-large) {
    grid-template-rows: auto 3fr 80px;
    margin: 0px auto 20px auto;
    max-width: 512px;
    border: 1px solid $gray-300;
    border-radius: 12px;
    box-shadow: 0px 2px 4px -2px rgba(24, 39, 75, 0.12), 0px 4px 4px -2px rgba(24, 39, 75, 0.08);
    min-height: auto;
    height: auto;
  }
}

.payment-link-content {
  padding: 0px 24px;

  @media (min-width: $breakpoint-large) {
    padding: 0px 36px;
    padding-bottom: 20px;
  }
}

.prclx-logo {
  display: flex;

  &.loading {
    display: none;

    @media (min-width: $breakpoint-large) {
      display: flex;
    }
  }

  img {
    margin: 16px auto 0px auto;
  }

  @media (min-width: $breakpoint-large) {
    img {
      margin-top: 24px;
    }
  }
}

.payment-link-footer {
  @extend .w-100;
  @extend .d-flex;
  @extend .justify-content-center;
  @extend .align-items-center;

  padding: 0px 24px 24px 24px;

  @media (min-width: $breakpoint-large) {
    padding: 16px 0px;
    background-color: $gray-50;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
}
</style>
